/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { UploadFileResponse } from '../models/UploadFileResponse';
import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class ImageService {

    /**
     * Upload a file
     * @result UploadFileResponse
     * @throws ApiError
     */
    public static async imageControllerUploadImage(): Promise<UploadFileResponse> {

        const result = await __request({
            method: 'post',
            path: `/api/image`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Upload a private file
     * @result UploadFileResponse
     * @throws ApiError
     */
    public static async imageControllerUploadPrivateImage(): Promise<UploadFileResponse> {

        const result = await __request({
            method: 'post',
            path: `/api/image/private`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get an image
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async imageControllerGetImage(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/image/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get a private image (placeholder)
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async imageControllerGetPrivateImage(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/image/private/${id}`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get a private image (Admin)
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async imageControllerGetPrivateImageAdmin(
        id: string,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/image/private/${id}/admin`,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/ImageService.ts